import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/features/auth/store'

interface Props {
  permission?: string
  anyOf?: string[]
  children: React.ReactNode
}

export default function RequirePermission({ permission, anyOf, children }: Props) {
  const hasPermission = useAuthStore(s => s.hasPermission)

  const allowed =
    (!permission || hasPermission(permission)) &&
    (!anyOf?.length || anyOf.some(p => hasPermission(p)))

  if (!allowed) return <Navigate to="/403" replace />
  return <>{children}</>
}
